module.exports = __webpack_public_path__ + "static/media/product_4.b00e6b7e.svg";